import { api } from '../config/api';

export interface Contact {
  id: number;
  phone_number: string;
  name?: string;
  email?: string;
  is_tenant: boolean;
  is_vendor: boolean;
}

export interface Message {
  id: number;
  openphone_id: string;
  direction: 'incoming' | 'outgoing';
  phone_number: string;
  contact?: Contact;
  property_id?: number;
  property?: any;
  body: string;
  media_urls?: string[];
  local_media_paths?: string[];
  timestamp: string;
  read: boolean;
  archived: boolean;
}

export const messagesService = {
  async getMessages(params?: {
    phone_number?: string;
    property_id?: number;
    archived?: boolean;
  }): Promise<Message[]> {
    const response = await api.get<Message[]>('/messages/', { params });
    return response.data;
  },

  async getPropertyMediaMessages(propertyId: number): Promise<Message[]> {
    const response = await api.get<Message[]>(`/properties/${propertyId}/media`);
    return response.data;
  },

  async updateMessage(messageId: number, data: {
    property_id?: number;
    archived?: boolean;
  }): Promise<Message> {
    const response = await api.patch<Message>(`/messages/${messageId}`, data);
    return response.data;
  }
};